<template>
  <div id="app" class="slds-p-bottom_xx-large">
    <nav-bar />
    
      <CampaignAnalysis @filterDataParent="searchCampaign" v-if="isSearchClicked"></CampaignAnalysis>
      <error />
      <router-view />
    
  </div>
</template>

<script>
import NavBar from "./components/NavBar";
import Error from "./components/Error";
import CampaignAnalysis from "./components/CampaignAnalysis";
export default {
  components: {
    NavBar,
    Error,
    CampaignAnalysis,
  },
  data() {
		return {
      childData: []
		};
  },
  methods: {
    searchCampaign(variable) {
      this.childData= variable;
    }
  },
  computed: {
      isSearchClicked() {
        return this.$route.name == 'home'
      },
      isCampaign() {
          return false
      }
    }
};
</script>